// extracted by mini-css-extract-plugin
export default {"sub-title":"sub-title_TSPrS"};